import Button from '@root/gatsby-contentful-core/src/components/button';
import Modal from '@root/gatsby-contentful-core/src/components/modal';
import PropTypes from '@root/vendor/prop-types';
import Responsive from '@root/core/src/utils/responsive';
import clockIcon from '@root/agents/src/assets/clock.svg';
import useAgentSchedule from '@root/agents/src/hooks/use-agent-schedule';
import { StyleSheet } from '@root/core/src/utils/styles';
import { regular, semiBold } from '@root/brand/src/assets/fonts/root-sans/emotion';

const suffix = (hour) => hour >= 12 ? 'p.m.' : 'a.m.';
const twelveHourFormat = (hour) => (hour + 11) % 12 + 1;

const format = (hour) => `${twelveHourFormat(hour)} ${suffix(hour)}`;

export default function AgentsOutOfBusinessHoursModal({
  onDismiss,
  isShowing,
}) {
  const { operatingHoursStart, operatingHoursEnd } = useAgentSchedule();

  return (
    <Modal
      renderCloseButton
      isShowing={isShowing}
      name={'joinroot-agents-out-of-business-hours-modal'}
      onClose={onDismiss}
    >
      <div css={styles.clockIconContainer}>
        <img
          src={clockIcon}
        />
      </div>

      <p css={styles.text}>
        Our Root agents are not currently available, but you can call us during regular business hours:
      </p>
      <p css={styles.openingHours}>
        {format(operatingHoursStart)} to {format(operatingHoursEnd)} ET, Monday-Friday
      </p>

      <Button
        css={styles.continueButton}
        onClick={onDismiss}
      >
        Got it
      </Button>
    </Modal>
  );
}

const styles = StyleSheet.create({
  text: {
    marginTop: 40,
    fontSize: 18,
    ...regular(),
  },
  openingHours: {
    marginTop: 10,
    fontSize: 18,
    ...regular(),
  },
  clockIconContainer: {
    textAlign: 'center',
  },
  continueButton: {
    marginTop: 30,
    width: '100%',
    ...semiBold(),
    ...Responsive.lessThanSm({
      marginBottom: 20,
    }),
  },
});

AgentsOutOfBusinessHoursModal.propTypes = {
  isShowing: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
};
